import { render, staticRenderFns } from "./FlagInappropriateModal.vue?vue&type=template&id=a474e4b4&scoped=true"
import script from "./FlagInappropriateModal.vue?vue&type=script&lang=js"
export * from "./FlagInappropriateModal.vue?vue&type=script&lang=js"
import style0 from "./FlagInappropriateModal.vue?vue&type=style&index=0&id=a474e4b4&prod&lang=stylus&scoped=true"
import style1 from "./FlagInappropriateModal.vue?vue&type=style&index=1&id=a474e4b4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a474e4b4",
  null
  
)

export default component.exports